'use client';
import { memo } from 'react';
import { useCycle } from 'framer-motion';
import { AccordionButton, AccordionItem, AccordionPanel, Text } from '@chakra-ui/react';

import NextImage from 'shared/NextImage';
import { TextParser } from './TextParser';

import Plus from 'assets/icons/plus.svg';
import Minus from 'assets/icons/minus.svg';
import { DEFAULT_BORDER, DEFAULT_BORDER_RADIUS, EMPTY_OBJECT } from 'constants/global';

const CustomAccordionItemComponent = ({ title, content, ...props }) => {
  const [isExpanded, toggleIsExpanded] = useCycle(false, true);

  return (
    <AccordionItem
      w="full"
      transition="background-color .2s, border .2s"
      bgColor={isExpanded ? 'transparent' : 'bg.grayLight'}
      border={DEFAULT_BORDER}
      borderColor={isExpanded ? 'text.black' : 'transparent'}
      borderRadius={DEFAULT_BORDER_RADIUS}
      textAlign="left"
      {...props}
    >
      <AccordionButton
        w="full"
        p="32px 48px"
        gap="15px"
        _hover={EMPTY_OBJECT}
        onClick={() => toggleIsExpanded()}
      >
        <Text
          textStyle="h4"
          fontSize={{ mobile: '16px', laptop: '24px' }}
          flex="1"
          textAlign="left"
        >
          {title}
        </Text>

        <NextImage
          src={isExpanded ? Minus : Plus}
          alt={`Иконка ${isExpanded ? 'минуса' : 'плюса'}`}
          w="auto"
          h="auto"
        />
      </AccordionButton>

      <AccordionPanel motionProps={{ unmountOnExit: true }} p="8px 48px 48px">
        {<TextParser content={content} />}
      </AccordionPanel>
    </AccordionItem>
  );
};

export const CustomAccordionItem = memo(CustomAccordionItemComponent);
